/* Bentior theme JS — origineel, dependency-vrij */
(function () {
  'use strict';

  function money(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  /* Vertaalde teksten (gezet in snippets/cart-drawer.liquid) met NL als terugval */
  function T(key, fallback) {
    var s = window.AffiniaT;
    return (s && s[key]) || fallback;
  }

  /* ============================================================
     PRODUCT: variantkiezer
     ============================================================ */
  function initProductForm(form) {
    var dataEl = document.getElementById('ProductJson-' + form.dataset.productId);
    if (!dataEl) return;
    var product;
    try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var idInput = form.querySelector('input[name="id"]');
    var priceEl = document.querySelector('[data-product-price]');
    var compareEl = document.querySelector('[data-product-compare]');
    var saveEl = document.querySelector('[data-product-save]');
    var buyBtn = form.querySelector('[data-add-to-cart]');
    var buyText = form.querySelector('[data-add-to-cart-text]');

    function selectedOptions() {
      var opts = [];
      form.querySelectorAll('[data-option-index]').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        if (checked) opts[parseInt(group.dataset.optionIndex, 10)] = checked.value;
      });
      return opts;
    }

    function findVariant(opts) {
      /* Product zonder variantopties (alleen "Default Title"): geen keuzerondjes
         in de DOM, dus altijd de eerste (enige) variant gebruiken. */
      if (!form.querySelector('[data-option-index]')) return product.variants[0];
      return product.variants.find(function (v) {
        return v.options.every(function (val, i) { return val === opts[i]; });
      });
    }

    /* Galerij wisselen op variant: match op bestandsnaam van de variant-afbeelding */
    function updateGallery(variant) {
      if (!variant || !variant.featured_image || !variant.featured_image.src) return;
      var file = variant.featured_image.src.split('?')[0].split('/').pop();
      if (!file) return;
      var items = document.querySelectorAll('[data-gallery-item]');
      var match = null;
      items.forEach(function (t) {
        if (!match && (t.dataset.src || '').indexOf('/' + file) !== -1) match = t;
      });
      if (match && match.scrollIntoView) {
        match.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
        return;
      }
      /* fallback voor oude galerij-markup */
      var thumbs = document.querySelectorAll('[data-gallery-thumb]');
      var tmatch = null;
      thumbs.forEach(function (t) {
        if (!tmatch && (t.dataset.src || '').indexOf('/' + file) !== -1) tmatch = t;
      });
      if (tmatch) { tmatch.click(); return; }
      var main = document.querySelector('[data-gallery-main] img');
      if (main) { main.src = variant.featured_image.src; main.srcset = ''; }
    }

    function onChange() {
      var variant = findVariant(selectedOptions());
      if (variant) {
        idInput.value = variant.id;
        if (priceEl) priceEl.textContent = money(variant.price);
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        if (compareEl) {
          if (onSale) {
            compareEl.textContent = money(variant.compare_at_price);
            compareEl.hidden = false;
            if (priceEl) priceEl.classList.add('price__sale');
          } else {
            compareEl.hidden = true;
            if (priceEl) priceEl.classList.remove('price__sale');
          }
        }
        if (saveEl) {
          if (onSale) {
            var pct = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
            saveEl.textContent = pct + '% ' + (saveEl.dataset.badgeSuffix || T('badge_suffix', 'KORTING'));
            saveEl.hidden = false;
          } else {
            saveEl.hidden = true;
          }
        }
        if (buyBtn) {
          buyBtn.disabled = !variant.available;
          if (buyText) buyText.textContent = variant.available ? buyText.dataset.add : buyText.dataset.soldout;
        }
        updateGallery(variant);
        if (history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          history.replaceState({}, '', url.toString());
        }
      } else if (buyBtn) {
        buyBtn.disabled = true;
        if (buyText) buyText.textContent = buyText.dataset.unavailable;
      }
      syncNameFields(form);
      syncBirthstoneFields(form);
    }

    /* Geselecteerde waarde tonen in het optielabel (bij swatches) */
    function syncOptionLabels() {
      form.querySelectorAll('[data-option-index]').forEach(function (group) {
        var span = group.querySelector('[data-selected-value]');
        var checked = group.querySelector('input:checked');
        if (span && checked) span.textContent = checked.value;
      });
    }

    form.addEventListener('change', function (e) {
      if (e.target.matches('[data-option-input]')) { onChange(); syncOptionLabels(); }
    });
    onChange();
    syncOptionLabels();

    /* Toevoegen aan winkelwagen via AJAX -> drawer openen */
    form.addEventListener('submit', function (e) {
      if (!window.fetch || !window.FormData) return; // fallback: normale submit
      e.preventDefault();
      if (!form.reportValidity()) return;
      if (buyBtn) buyBtn.disabled = true;
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (buyBtn) buyBtn.disabled = false;
          if (!res.ok) {
            alert(res.data.description || res.data.message || T('error', 'Er ging iets mis. Probeer het opnieuw.'));
            return;
          }
          /* Klaviyo: Added to Cart event voor abandonment-flows */
          try {
            var kl = window.klaviyo || window._learnq;
            var v2 = findVariant(selectedOptions()) || product.variants[0];
            if (kl && kl.push) {
              kl.push(['track', 'Added to Cart', {
                ProductName: product.title,
                ProductID: product.id,
                VariantName: v2 ? v2.title : '',
                Price: v2 ? v2.price / 100 : product.price / 100,
                URL: window.location.origin + '/products/' + form.dataset.productHandle,
                ImageURL: product.featured_image ? ('https:' + product.featured_image).replace('https:https:', 'https:') : ''
              }]);
            }
          } catch (err) {}
          if (window.BentiorDrawer) window.BentiorDrawer.open();
        })
        .catch(function () { form.submit(); });
    });
  }

  /* ============================================================
     PERSONALISATIE: dynamische naamvelden
     ============================================================ */
  function syncNameFields(form) {
    var wrap = form.querySelector('[data-name-fields]');
    if (!wrap) return;
    var label = wrap.dataset.label || 'Naam';
    var count = 1;
    form.querySelectorAll('[data-option-index]').forEach(function (group) {
      var name = (group.dataset.optionName || '').toLowerCase();
      if (name.indexOf('aantal') !== -1) {
        var checked = group.querySelector('input:checked');
        var n = checked ? parseInt(checked.value, 10) : NaN;
        if (!isNaN(n)) count = n;
      }
    });

    var current = wrap.querySelectorAll('input[type="text"]');
    if (current.length === count) return;

    var values = [];
    current.forEach(function (i) { values.push(i.value); });
    wrap.innerHTML = '';
    for (var i = 1; i <= count; i++) {
      var field = document.createElement('div');
      field.className = 'form-field';
      var lab = document.createElement('label');
      lab.setAttribute('for', 'PersonalizationName' + i);
      lab.textContent = label + ' ' + i;
      var input = document.createElement('input');
      input.type = 'text';
      input.id = 'PersonalizationName' + i;
      input.name = 'properties[' + label + ' ' + i + ']';
      input.maxLength = 14;
      input.required = true;
      if (values[i - 1]) input.value = values[i - 1];
      field.appendChild(lab);
      field.appendChild(input);
      wrap.appendChild(field);
    }
  }

  /* ============================================================
     PERSONALISATIE: dynamische geboortesteen-keuzemenu's
     ============================================================ */
  function syncBirthstoneFields(form) {
    var wrap = form.querySelector('[data-birthstone-fields]');
    if (!wrap) return;
    var count = 1;
    form.querySelectorAll('[data-option-index]').forEach(function (group) {
      var name = (group.dataset.optionName || '').toLowerCase();
      if (name.indexOf('aantal') !== -1) {
        var checked = group.querySelector('input:checked');
        var n = checked ? parseInt(checked.value, 10) : NaN;
        if (!isNaN(n)) count = n;
      }
    });

    var current = wrap.querySelectorAll('select');
    if (current.length === count) return;

    var stones = [
      'Januari – Granaat', 'Februari – Amethist', 'Maart – Aquamarijn',
      'April – Diamant (kristal)', 'Mei – Smaragd', 'Juni – Parel',
      'Juli – Robijn', 'Augustus – Peridot', 'September – Saffier',
      'Oktober – Opaal', 'November – Citrien', 'December – Blauwtopaas'
    ];
    var values = [];
    current.forEach(function (s) { values.push(s.value); });
    wrap.innerHTML = '';
    for (var i = 1; i <= count; i++) {
      var field = document.createElement('div');
      field.className = 'form-field';
      var lab = document.createElement('label');
      lab.setAttribute('for', 'PersBirthstone' + i);
      lab.textContent = 'Geboortesteen ' + i;
      var select = document.createElement('select');
      select.id = 'PersBirthstone' + i;
      select.name = 'properties[Geboortesteen ' + i + ']';
      select.required = true;
      var ph = document.createElement('option');
      ph.value = '';
      ph.disabled = true;
      ph.selected = true;
      ph.textContent = 'Kies een maand';
      select.appendChild(ph);
      stones.forEach(function (stone) {
        var opt = document.createElement('option');
        opt.value = stone;
        opt.textContent = stone;
        select.appendChild(opt);
      });
      if (values[i - 1]) select.value = values[i - 1];
      field.appendChild(lab);
      field.appendChild(select);
      wrap.appendChild(field);
    }
  }

  /* ============================================================
     GALERIJ
     ============================================================ */
  function initGallery() {
    /* Mobiele carrousel + thumbnail-strip */
    var grid = document.querySelector('[data-gallery-grid]');
    var strip = document.querySelector('[data-gallery-thumbstrip]');
    if (grid && strip) {
      var thumbBtns = strip.querySelectorAll('[data-gallery-thumbbtn]');
      var galItems = grid.querySelectorAll('[data-gallery-item]');
      function setActive(i) {
        thumbBtns.forEach(function (b, n) { b.classList.toggle('is-active', n === i); });
        var act = thumbBtns[i];
        if (act && act.scrollIntoView) act.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      }
      thumbBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var i = parseInt(btn.dataset.index, 10) || 0;
          var item = galItems[i];
          if (!item) return;
          if (window.matchMedia('(max-width: 850px)').matches) {
            grid.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
          } else if (item.scrollIntoView) {
            item.scrollIntoView({ block: 'center', behavior: 'smooth' });
          }
          setActive(parseInt(btn.dataset.index, 10) || 0);
        });
      });
      var scrollTimer = null;
      grid.addEventListener('scroll', function () {
        if (!window.matchMedia('(max-width: 850px)').matches) return;
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          var w = grid.clientWidth || 1;
          var i = Math.round(grid.scrollLeft / w);
          if (i < 0) i = 0;
          if (i > galItems.length - 1) i = galItems.length - 1;
          setActive(i);
        }, 80);
      }, { passive: true });
    }

    var main = document.querySelector('[data-gallery-main] img');
    if (!main) return;
    document.querySelectorAll('[data-gallery-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        main.src = btn.dataset.src;
        main.srcset = '';
        document.querySelectorAll('[data-gallery-thumb]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
      });
    });
  }

  /* ============================================================
     CART DRAWER (incl. geschenkdoos-schakelaar)
     ============================================================ */
  var Drawer = (function () {
    var root = null, productCache = {};

    function el(sel) { return root ? root.querySelector(sel) : null; }

    function getProduct(handle) {
      if (productCache[handle]) return Promise.resolve(productCache[handle]);
      return fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { if (p) productCache[handle] = p; return p; });
    }

    /* Geschenkdoos = los product dat als eigen regel in de winkelwagen komt */
    var giftCardEl = document.querySelector('[data-drawer-addon]');
    var GIFT_HANDLE = (giftCardEl && giftCardEl.getAttribute('data-gift-handle')) || 'exclusieve-geschenkdoos';

    function giftVariant() {
      var prod = productCache[GIFT_HANDLE];
      return prod && prod.variants && prod.variants.length ? prod.variants[0] : null;
    }

    function giftItem(cart) {
      return cart.items.find(function (i) { return i.handle === GIFT_HANDLE; }) || null;
    }

    function renderItems(cart, products) {
      var wrap = el('[data-drawer-items]');
      wrap.innerHTML = '';
      cart.items.forEach(function (item, idx) {
        var prod = products[item.handle];
        var variant = prod ? prod.variants.find(function (v) { return v.id === item.variant_id; }) : null;
        var compare = variant && variant.compare_at_price && variant.compare_at_price > variant.price
          ? variant.compare_at_price * item.quantity : 0;

        var div = document.createElement('div');
        div.className = 'drawer-item';
        var img = item.image ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/, '_160x160$1$2') + '" alt="">' : '';
        var props = '';
        for (var key in item.properties) {
          if (item.properties.hasOwnProperty(key) && key.charAt(0) !== '_' && item.properties[key]) {
            var val = String(item.properties[key]);
            props += '<div class="drawer-item__props">' + key + ': ' + (val.indexOf('/uploads/') !== -1 ? T('photo_added', 'foto toegevoegd') : val) + '</div>';
          }
        }
        div.innerHTML =
          '<div class="drawer-item__media">' + img + '</div>' +
          '<div class="drawer-item__info">' +
            '<p class="drawer-item__title">' + item.product_title + '</p>' +
            (item.variant_title ? '<div class="drawer-item__variant">' + item.variant_title + '</div>' : '') +
            props +
            '<div class="drawer-item__bottom">' +
              '<span class="qty-stepper">' +
                '<button type="button" data-qty-minus aria-label="' + T('less', 'Minder') + '">−</button>' +
                '<span>' + item.quantity + '</span>' +
                '<button type="button" data-qty-plus aria-label="' + T('more', 'Meer') + '">+</button>' +
              '</span>' +
              '<span class="drawer-item__prices">' +
                (compare ? '<s>' + money(compare) + '</s>' : '') +
                '<strong>' + money(item.final_line_price) + '</strong>' +
              '</span>' +
            '</div>' +
          '</div>' +
          '<button type="button" class="drawer-item__remove" data-item-remove aria-label="' + T('remove', 'Verwijderen') + '">×</button>';

        div.querySelector('[data-qty-minus]').addEventListener('click', function () { changeQty(item.key, item.quantity - 1); });
        div.querySelector('[data-qty-plus]').addEventListener('click', function () { changeQty(item.key, item.quantity + 1); });
        div.querySelector('[data-item-remove]').addEventListener('click', function () { changeQty(item.key, 0); });
        wrap.appendChild(div);
      });
    }

    function renderAddon(cart) {
      var card = el('[data-drawer-addon]');
      if (!card) return null;
      var toggle = el('[data-drawer-addon-toggle]');
      var priceSpan = el('[data-drawer-addon-price]');
      var gift = giftItem(cart);
      var others = cart.items.filter(function (i) { return i.handle !== GIFT_HANDLE; });

      if (!others.length) { card.hidden = true; return null; }
      card.hidden = false;
      var on = !!gift;
      toggle.setAttribute('aria-checked', on ? 'true' : 'false');
      var v = giftVariant();
      if (priceSpan) priceSpan.textContent = v ? '+' + money(v.price) : '';
      return { gift: gift, on: on };
    }

    function renderTotals(cart, products) {
      var savings = 0;
      cart.items.forEach(function (item) {
        var prod = products[item.handle];
        var variant = prod ? prod.variants.find(function (v) { return v.id === item.variant_id; }) : null;
        if (variant && variant.compare_at_price && variant.compare_at_price > variant.price) {
          savings += (variant.compare_at_price - variant.price) * item.quantity;
        }
      });
      savings += cart.total_discount || 0;
      var row = el('[data-drawer-savings]');
      row.hidden = savings <= 0;
      if (savings > 0) el('[data-drawer-savings-value]').textContent = '−' + money(savings);
      el('[data-drawer-subtotal]').textContent = money(cart.total_price);
      el('[data-drawer-checkout-total]').textContent = money(cart.total_price);
      el('[data-drawer-count]').textContent = cart.item_count;
      var shipBar = el('[data-shipping-bar]');
      if (shipBar) {
        shipBar.hidden = cart.item_count === 0;
        var threshold = parseInt(shipBar.dataset.threshold, 10) || 10000;
        var text = el('[data-shipping-text]');
        var fill = el('[data-shipping-fill]');
        var pct = Math.min(100, Math.round((cart.total_price / threshold) * 100));
        if (fill) fill.style.width = pct + '%';
        if (text) {
          if (cart.total_price >= threshold) {
            text.innerHTML = T('shipping_reached', '🎉 Je hebt <strong>gratis verzending</strong>!');
            shipBar.classList.add('is-reached');
          } else {
            text.innerHTML = T('shipping_remaining', 'Nog <strong>{amount}</strong> tot gratis verzending').replace('{amount}', money(threshold - cart.total_price));
            shipBar.classList.remove('is-reached');
          }
        }
      }
      var headerCount = document.querySelector('[data-cart-count]');
      if (headerCount) { headerCount.textContent = cart.item_count; headerCount.hidden = cart.item_count === 0; }
    }

    var addonState = null;

    /* Upsells: "Vaak samen gekocht" — bestsellers die nog niet in de wagen zitten */
    var upsellData = null;

    function upsellProducts() {
      if (upsellData) return upsellData;
      var tag = root ? root.querySelector('[data-upsell-data]') : null;
      if (!tag) { upsellData = []; return upsellData; }
      try { upsellData = JSON.parse(tag.textContent) || []; } catch (e) { upsellData = []; }
      return upsellData;
    }

    function renderUpsells(cart) {
      var box = el('[data-drawer-upsell]');
      var track = el('[data-upsell-track]');
      if (!box || !track) return;
      if (!cart.item_count) { box.hidden = true; return; }
      var inCart = {};
      inCart[GIFT_HANDLE] = true;
      cart.items.forEach(function (i) { inCart[i.handle] = true; });
      var picks = upsellProducts().filter(function (p) { return !inCart[p.handle]; }).slice(0, 4);
      if (!picks.length) { box.hidden = true; return; }
      box.hidden = false;
      box.classList.toggle('drawer-upsell--single', picks.length === 1);
      track.innerHTML = '';
      picks.forEach(function (p) {
        var img = p.img && p.img.indexOf('//') === 0 ? 'https:' + p.img : p.img;
        var pct = p.compare > p.price ? Math.round((p.compare - p.price) * 100 / p.compare) : 0;
        var card = document.createElement('div');
        card.className = picks.length === 1 ? 'upsell-card upsell-card--single' : 'upsell-card';
        card.innerHTML =
          '<a class="upsell-card__media" href="' + p.url + '">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</a>' +
          '<a class="upsell-card__title" href="' + p.url + '">' + p.title + '</a>' +
          '<div class="upsell-card__prices">' +
            (p.compare > p.price ? '<s>' + money(p.compare) + '</s>' : '') +
            '<strong>' + money(p.price) + '</strong>' +
            (pct ? '<span class="upsell-card__badge">−' + pct + '%</span>' : '') +
          '</div>' +
          (p.simple || (p.opts && p.vars)
            ? ''
            : '<a class="upsell-card__add upsell-card__add--link" href="' + p.url + '">' + T('view', 'Bekijk') + '</a>');
        function addById(vid, btn) {
          btn.disabled = true;
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: vid, quantity: 1 })
          }).then(refresh).then(function () { btn.disabled = false; })
            .catch(function () { btn.disabled = false; refresh(); });
        }
        var controls = document.createElement('div');
        controls.className = 'upsell-card__controls';
        if (p.simple) {
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'upsell-card__add'; b.textContent = T('add', '+ Toevoegen');
          b.addEventListener('click', function () { addById(p.vid, b); });
          controls.appendChild(b);
        } else if (p.opts && p.vars) {
          var firstAv = null;
          p.vars.forEach(function (v) { if (!firstAv && v.av) firstAv = v; });
          if (!firstAv) firstAv = p.vars[0];
          var selects = [];
          p.opts.forEach(function (opt, oi) {
            var sel = document.createElement('select');
            sel.className = 'upsell-card__select';
            sel.setAttribute('aria-label', opt.n);
            var isSize = /maat|größe|grösse/i.test(opt.n || '');
            if (isSize) {
              var ph2 = document.createElement('option');
              ph2.value = ''; ph2.disabled = true; ph2.selected = true; ph2.textContent = T('choose', 'Kies uw maat');
              sel.appendChild(ph2);
            }
            opt.v.forEach(function (val) {
              var o = document.createElement('option');
              o.value = val; o.textContent = val;
              if (!isSize && firstAv && firstAv.o[oi] === val) o.selected = true;
              sel.appendChild(o);
            });
            selects.push(sel);
            controls.appendChild(sel);
          });
          var b2 = document.createElement('button');
          b2.type = 'button'; b2.className = 'upsell-card__add'; b2.textContent = T('add', '+ Toevoegen');
          b2.addEventListener('click', function () {
            var chosen = selects.map(function (s) { return s.value; });
            if (chosen.indexOf('') !== -1) {
              var tph = b2.textContent;
              b2.textContent = T('choose_first', 'Kies eerst een maat');
              setTimeout(function () { b2.textContent = tph; }, 1600);
              return;
            }
            var match = null;
            p.vars.forEach(function (v) {
              if (match) return;
              var ok = true;
              chosen.forEach(function (cv, ci) { if (v.o[ci] !== cv) ok = false; });
              if (ok) match = v;
            });
            if (!match || !match.av) {
              var t = b2.textContent;
              b2.textContent = T('unavailable', 'Niet leverbaar');
              setTimeout(function () { b2.textContent = t; }, 1600);
              return;
            }
            addById(match.id, b2);
          });
          controls.appendChild(b2);
        }
        if (controls.children.length) card.appendChild(controls);
        track.appendChild(card);
      });
    }

    function refresh() {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          /* Geschenkdoos als enige regel in de wagen? Dan automatisch verwijderen. */
          var gift = giftItem(cart);
          if (gift && cart.items.length === 1) {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: gift.key, quantity: 0 })
            }).then(refresh);
          }
          var handles = { };
          handles[GIFT_HANDLE] = true;
          cart.items.forEach(function (i) { handles[i.handle] = true; });
          return Promise.all(Object.keys(handles).map(getProduct)).then(function () {
            var empty = cart.item_count === 0;
            el('[data-drawer-empty]').hidden = !empty;
            el('[data-drawer-footer]').hidden = empty;
            renderItems(cart, productCache);
            addonState = renderAddon(cart);
            renderUpsells(cart);
            renderTotals(cart, productCache);
          });
        });
    }

    function changeQty(key, qty) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(refresh);
    }

    function toggleAddon() {
      if (!addonState) return;
      var toggle = el('[data-drawer-addon-toggle]');
      toggle.disabled = true;
      var action;
      if (addonState.on && addonState.gift) {
        action = fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: addonState.gift.key, quantity: 0 })
        });
      } else {
        var v = giftVariant();
        if (!v) { toggle.disabled = false; return; }
        action = fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: v.id, quantity: 1 })
        });
      }
      action.then(refresh).then(function () { toggle.disabled = false; })
        .catch(function () { toggle.disabled = false; refresh(); });
    }

    function open() {
      if (!root) return;
      refresh().then(function () {
        root.hidden = false;
        document.body.classList.add('drawer-open');
      });
    }

    function close() {
      if (!root) return;
      root.hidden = true;
      document.body.classList.remove('drawer-open');
    }

    function init() {
      root = document.getElementById('CartDrawer');
      if (!root) return;
      root.querySelectorAll('[data-drawer-close]').forEach(function (b) {
        b.addEventListener('click', close);
      });
      var toggle = el('[data-drawer-addon-toggle]');
      if (toggle) toggle.addEventListener('click', toggleAddon);
      var checkout = el('[data-drawer-checkout]');
      if (checkout) checkout.addEventListener('click', function () { window.location.href = '/checkout'; });
      document.querySelectorAll('[data-cart-open]').forEach(function (link) {
        link.addEventListener('click', function (e) {
          if (!window.fetch) return;
          e.preventDefault();
          open();
        });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !root.hidden) close();
      });
    }

    return { init: init, open: open, close: close, refresh: refresh };
  })();
  window.BentiorDrawer = Drawer;

  /* Complete de look: variant kiezen + toevoegen */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-look-add-var]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var wrap = btn.closest('[data-look-variants]');
    if (!wrap) return;
    var dataTag = wrap.querySelector('[data-look-data]');
    var vars = [];
    try { vars = JSON.parse(dataTag.textContent) || []; } catch (err) { return; }
    var chosen = Array.prototype.map.call(wrap.querySelectorAll('[data-look-opt]'), function (s) { return s.value; });
    if (chosen.indexOf('') !== -1) {
      var t0 = btn.textContent;
      btn.textContent = T('choose_first', 'Kies eerst een maat');
      setTimeout(function () { btn.textContent = t0; }, 1600);
      return;
    }
    var match = null;
    vars.forEach(function (v) {
      if (match) return;
      var ok = true;
      chosen.forEach(function (cv, ci) { if (v.o[ci] !== cv) ok = false; });
      if (ok) match = v;
    });
    if (!match || !match.av) {
      var t = btn.textContent;
      btn.textContent = T('unavailable', 'Niet leverbaar');
      setTimeout(function () { btn.textContent = t; }, 1600);
      return;
    }
    btn.disabled = true;
    var oldTxt = btn.textContent;
    btn.textContent = '…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: match.id, quantity: 1 })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        btn.textContent = T('added', '✓ Toegevoegd');
        if (window.BentiorDrawer) { window.BentiorDrawer.refresh(); window.BentiorDrawer.open(); }
        setTimeout(function () { btn.textContent = oldTxt; btn.disabled = false; }, 1500);
      })
      .catch(function () { btn.textContent = oldTxt; btn.disabled = false; });
  });

  /* Complete de look: direct toevoegen */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-look-add]');
    if (!btn) return;
    e.preventDefault();
    var vid = parseInt(btn.dataset.lookAdd, 10);
    if (!vid || btn.disabled) return;
    btn.disabled = true;
    var oldTxt = btn.textContent;
    btn.textContent = '…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: vid, quantity: 1 })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        btn.textContent = T('added', '✓ Toegevoegd');
        if (window.BentiorDrawer) { window.BentiorDrawer.refresh(); window.BentiorDrawer.open(); }
        setTimeout(function () { btn.textContent = oldTxt; btn.disabled = false; }, 1500);
      })
      .catch(function () { btn.textContent = oldTxt; btn.disabled = false; });
  });

  /* ============================================================
     CART-PAGINA (fallback)
     ============================================================ */
  function initCartPage() {
    document.querySelectorAll('[data-cart-qty]').forEach(function (input) {
      input.addEventListener('change', function () {
        input.closest('form').submit();
      });
    });
  }

  /* ============================================================
     REVIEW-CARROUSEL (v1.7)
     ============================================================ */
  function initReviewCarousel() {
    document.querySelectorAll('[data-review-carousel]').forEach(function (root) {
      var track = root.querySelector('[data-review-track]');
      var prev = root.querySelector('[data-carousel-prev]');
      var next = root.querySelector('[data-carousel-next]');
      if (!track || !prev || !next) return;

      function step() {
        var card = track.querySelector('.review-card') || track.firstElementChild;
        return card ? card.getBoundingClientRect().width + 16 : 320;
      }
      function update() {
        prev.disabled = track.scrollLeft <= 4;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
      }
      prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
      next.addEventListener('click', function () { track.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();

      /* Continu autoscrollen (reviews): langzaam doorlopen, oneindig, pauzeert bij interactie */
      if (root.dataset.autoscroll === '1' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches && track.children.length > 1) {
        var half = 0;
        function setupLoop() {
          track.innerHTML += track.innerHTML;
          root.classList.add('is-marquee');
          track.style.scrollBehavior = 'auto';
          half = track.scrollWidth / 2;
        }
        setupLoop();
        var paused = false, resumeTimer = null, lastT = null;
        var SPEED = 28; /* px per seconde */
        function tick(t) {
          if (!paused && half > 0) {
            if (lastT !== null) {
              track.scrollLeft += (t - lastT) * SPEED / 1000;
              if (track.scrollLeft >= half) track.scrollLeft -= half;
            }
            lastT = t;
          } else {
            lastT = t;
          }
          requestAnimationFrame(tick);
        }
        function pause() {
          paused = true;
          clearTimeout(resumeTimer);
        }
        function resumeSoon() {
          clearTimeout(resumeTimer);
          resumeTimer = setTimeout(function () { paused = false; }, 3000);
        }
        ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) {
          track.addEventListener(ev, pause, { passive: true });
        });
        ['pointerup', 'touchend'].forEach(function (ev) {
          track.addEventListener(ev, resumeSoon, { passive: true });
        });
        root.addEventListener('mouseenter', pause);
        root.addEventListener('mouseleave', resumeSoon);
        prev.addEventListener('click', function () { pause(); resumeSoon(); });
        next.addEventListener('click', function () { pause(); resumeSoon(); });
        document.addEventListener('visibilitychange', function () {
          if (document.hidden) { pause(); } else { resumeSoon(); }
        });
        window.addEventListener('resize', function () { half = track.scrollWidth / 2; });
        requestAnimationFrame(tick);
      }
    });
  }

  /* ============================================================
     MEGAMENU (v1.7) — klik/touch-ondersteuning naast hover
     ============================================================ */
  function initMegaMenu() {
    document.querySelectorAll('.mega').forEach(function (mega) {
      var trigger = mega.querySelector('.mega__trigger');
      if (!trigger) return;
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        var open = mega.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      document.addEventListener('click', function (e) {
        if (!mega.contains(e.target) && mega.classList.contains('is-open')) {
          mega.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && mega.classList.contains('is-open')) {
          mega.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
        }
      });
    });
  }

  /* ============================================================
     COOKIEBANNER (v2.2) — zelfgecodeerd, koppelt aan Shopify
     Customer Privacy API wanneer beschikbaar
     ============================================================ */
  function initCookieBanner() {
    var banner = document.querySelector('[data-cookie-banner]');
    if (!banner) return;

    var KEY = 'bentior-cookie-consent';
    var saved = null;
    try { saved = localStorage.getItem(KEY); } catch (e) {}
    if (saved) return;

    setTimeout(function () {
      banner.hidden = false;
      requestAnimationFrame(function () { banner.classList.add('is-visible'); });
    }, 800);

    function applyShopifyConsent(accepted) {
      try {
        if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
          window.Shopify.loadFeatures([
            { name: 'consent-tracking-api', version: '0.1' }
          ], function (error) {
            if (error) return;
            try {
              window.Shopify.customerPrivacy.setTrackingConsent({
                marketing: accepted,
                analytics: accepted,
                preferences: accepted,
                sale_of_data: accepted
              }, function () {});
            } catch (e) {}
          });
        }
      } catch (e) {}
    }

    function close(accepted) {
      try { localStorage.setItem(KEY, accepted ? 'accepted' : 'declined'); } catch (e) {}
      applyShopifyConsent(accepted);
      banner.classList.remove('is-visible');
      setTimeout(function () { banner.hidden = true; }, 350);
    }

    banner.querySelectorAll('[data-cookie-accept]').forEach(function (b) {
      b.addEventListener('click', function () { close(true); });
    });
    banner.querySelectorAll('[data-cookie-decline]').forEach(function (b) {
      b.addEventListener('click', function () { close(false); });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var pf = document.querySelector('[data-product-form]');
    if (pf) initProductForm(pf);
    initGallery();
    initCartPage();
    Drawer.init();
    initReviewCarousel();
    initMegaMenu();
    initCookieBanner();
  });
})();

/* ============================================================
   QUICK-ADD OP PRODUCTKAARTEN
   ============================================================ */
(function () {
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-qa-toggle]');
    if (t) {
      e.preventDefault();
      var wrap = t.closest('[data-qa-wrap]');
      var panel = wrap && wrap.querySelector('.product-card__qa-panel');
      if (!panel) return;
      var open = panel.hidden;
      document.querySelectorAll('.product-card__qa-panel').forEach(function (p) { p.hidden = true; });
      panel.hidden = !open;
      return;
    }
    if (!e.target.closest('.product-card__qa-panel')) {
      document.querySelectorAll('.product-card__qa-panel').forEach(function (p) { p.hidden = true; });
    }
  });
})();
